export default __webpack_public_path__ + "static/media/icn-bac-passed.d33847e7.svg";